import { render, staticRenderFns } from "./TableNotRelevant.vue?vue&type=template&id=77bf8967&"
import script from "./TableNotRelevant.vue?vue&type=script&lang=ts&"
export * from "./TableNotRelevant.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports